<template>
  <section class="parent">
    <div class="imageParent">
      <img
        class="image"
        src="~@/assets/netherlands/city-template-cta-desktop.webp"
      />
      <p class="question">
        {{ $t('homepage.cta_question') }}
      </p>
    </div>
    <div class="end">
      <p class="text">
        {{ $t(`city_template.cta_text_1.${normalizeCityName(city)}`) }}
      </p>
      <ExternalFormCTAButton />
      <p class="text">{{ $t('city_template.cta_text_2') }}</p>
    </div>
  </section>
</template>

<script>
import normalizeCityName from '@/shared/normalizeCityName';
import ExternalFormCTAButton from '../../HomePage/StartScreen/ExternalFormCTAButton.vue';

export default {
  components: { ExternalFormCTAButton },
  props: ['city'],
  methods: {
    normalizeCityName,
  },
};
</script>

<style scoped>
.imageParent {
  display: grid;
  min-height: 375px;
  text-align: left;
}
.image {
  display: block;
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  font-family: Lato;
}
.question {
  grid-column: 1;
  grid-row: 1;
  letter-spacing: 2.4px;
  color: #ffffff;
  opacity: 1;
  width: 80%;
  height: fit-content;
  align-self: center;
  justify-self: center;
  font-weight: bold;
  font-size: 40px;
  font-family: 'Foco';
}
.end {
  background: #2b4047;
  padding: 2em 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.text {
  margin: 1.5em 0;
  color: #fff;
}
@media (min-width: 768px) {
  .parent {
    display: grid;
    height: 500px;
    grid-template-columns: 1fr 1fr;
  }
  .question {
    font-size: 60px;
    letter-spacing: 0px;
  }
  .text {
    font-size: 20px;
  }
  .end {
    align-items: flex-start;
    padding-left: 50px;
  }
}
</style>
